import { InjectionToken, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BtnCellRenderer } from './core/grid/btn-cell-render.component';
import { AgGridModule } from 'ag-grid-angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './core/header/header.component';
import { ToolbarComponent } from './core/toolbar/toolbar.component';
import { FooterComponent } from './core/footer/footer.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatListModule } from '@angular/material/list';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { FgaModule } from './fga/fga.module';
import { CommonModule } from '@angular/common'

import {
	NgxUiLoaderModule,
	NgxUiLoaderConfig
} from "ngx-ui-loader";

//Msal
import { MsalService, MSAL_INSTANCE, MsalGuard, MsalInterceptor, MsalBroadcastService } from './msal';
import { IPublicClientApplication, PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { MSAL_GUARD_CONFIG, MSAL_INTERCEPTOR_CONFIG } from './msal/constants';
import { MsalInterceptorConfig } from './msal/msal.interceptor.config';
import { environment } from 'src/environments/environment';
import { AprRatesComponent } from './page/masterdata/apr-rates/apr-rates.component';
import { DummyRoutesComponent } from './page/masterdata/dummy-routes/dummy-routes.component';
import { RailPointsComponent } from './page/masterdata/rail-points/rail-points.component';
import { SwitchPointsComponent } from './page/masterdata/switch-points/switch-points.component';
import { AddAprRateComponent } from './core/dialogs/add-apr-rate/add-apr-rate.component';
import { DeleteAPRCostComponent } from './core/dialogs/delete-apr-rate/delete-aprcost.component';
import { DeleteDummyRouteComponent } from './core/dialogs/delete-dummy-route/delete-dummy-route.component';
import { AddDummyRouteComponent } from './core/dialogs/add-dummy-route/add-dummy-route.component';
import { CopyAprRatesComponent } from './core/dialogs/copy-apr-rates/copy-apr-rates.component';
import { AddFiscalYearComponent } from './core/dialogs/add-fiscal-year/add-fiscal-year.component';
import { AddRailPointComponent } from './core/dialogs/add-rail-point/add-rail-point.component';
import { DeleteRailPointComponent } from './core/dialogs/delete-rail-point/delete-rail-point.component';
import { AddSwitchPointComponent } from './core/dialogs/add-switch-point/add-switch-point.component';
import { DeleteSwitchPointComponent } from './core/dialogs/delete-switch-point/delete-switch-point.component';
import { CostPlanStateService } from './service/cost-plan-state.service';
import { Constants } from './constants';
import { FgaService } from './fga/fga.service';
import { provideApollo } from 'apollo-angular';
import { InMemoryCache } from '@apollo/client/cache';
import { Unauthorized } from './page/unauthorized/unauthorized/unauthorized';
import { APP_INITIALIZER, inject, provideAppInitializer } from '@angular/core';
import {
    MsalInterceptorConfiguration,
    MsalGuardConfiguration,
  } from '@azure/msal-angular';
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { BreadcrumbComponent } from './core/breadcrumb/breadcrumb.component';
   
  ModuleRegistry.registerModules([ AllCommunityModule ]);
export function MSALInstanceFactory(): IPublicClientApplication {
	return new PublicClientApplication({
		auth: {
			clientId: environment.CLIENT_ID,
			authority: environment.TENANT_ID,
			redirectUri: environment.REDIRECT_URL
		}
	});
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map<string, Array<string>>();
    protectedResourceMap.set(
      environment.REDIRECT_URL,
      environment.SCOPES
    );
  
    return {
      interactionType: InteractionType.Redirect,
      protectedResourceMap,
    };
  }

  export function MSALGuardConfigFactory(): MsalGuardConfiguration {
    return {
      interactionType: InteractionType.Redirect,
      authRequest: {
        scopes: [...environment.SCOPES],
      },
      loginFailedRoute: '/unauthorized',
    };
  }
export function initializeMsal(instance: IPublicClientApplication): () => Promise<void> {
    return () => instance.initialize();
}
export const FGA_API_ENDPOINT = new InjectionToken<string>('FGA_API_ENDPOINT');
const ctr = "center-center"
const ngxUiLoaderConfig: NgxUiLoaderConfig =
{
	"bgsColor": "red",
	"bgsOpacity": 0.5,
	"bgsPosition": "bottom-right",
	"bgsSize": 60,
	"bgsType": "ball-spin-clockwise",
	"blur": 5,
	"delay": 0,
	"fastFadeOut": true,
	"fgsColor": "red",
	"fgsPosition": ctr,
	"fgsSize": 60,
	"fgsType": "ball-spin-clockwise",
	"gap": 24,
	"logoPosition": ctr,
	"logoSize": 120,
	"logoUrl": "",
	"masterLoaderId": "master",
	"overlayBorderRadius": "0",
	"overlayColor": "rgba(40, 40, 40, 0.8)",
	"pbColor": "red",
	"pbDirection": "ltr",
	"pbThickness": 3,
	"hasProgressBar": true,
	"text": "",
	"textColor": "#FFFFFF",
	"textPosition": ctr,
	"maxTime": -1,
	"minTime": 300
}

@NgModule({
  declarations: [
    BtnCellRenderer,
    AppComponent,
    HeaderComponent,
    ToolbarComponent,
    FooterComponent,
    AprRatesComponent,
    DummyRoutesComponent,
    RailPointsComponent,
    SwitchPointsComponent,
    AddAprRateComponent,
    DeleteAPRCostComponent,
    DeleteDummyRouteComponent,
    AddDummyRouteComponent,
    CopyAprRatesComponent,
    AddFiscalYearComponent,
    AddRailPointComponent,
    DeleteRailPointComponent,
    AddSwitchPointComponent,
    DeleteSwitchPointComponent,
    Unauthorized
  ],
  bootstrap: [AppComponent],
  imports: [BrowserModule,
    AppRoutingModule,
    AgGridModule,
    MatMenuModule,
    MatListModule,
    MatIconModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    MatDialogModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    BrowserAnimationsModule,
    NgxMatSelectSearchModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    MatTabsModule,
    FgaModule,
    CommonModule,
    BreadcrumbComponent],
  providers: [Constants,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    provideAppInitializer(() => {
      const msalInstance = inject(MSAL_INSTANCE);
      return msalInstance.initialize();
    }),
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    CostPlanStateService, provideHttpClient(withInterceptorsFromDi()),
    provideApollo(() => {
      return { cache: new InMemoryCache() };
    }),
    { provide: FGA_API_ENDPOINT, useValue: environment.APM_DS_URI },]
})
export class AppModule { }
